import React from "react";
import ReactQuill from "react-quill";
import "react-quill/dist/quill.snow.css";

export default function TextEditor({
    name,
    label,
    containerClassName = "",
    handleChange,
    value,
    error,
    height = 250,
    required = false,
    readOnly = false,
    placeholder = "",
}) {
    const modules = {
        toolbar: readOnly
            ? false
            : [
                  ["bold", "italic", "underline"],
                  [{ color: [] }, { background: [] }],
                  [{ list: "ordered" }, { list: "bullet" }],
              ],
    };

    const formats = [
        "bold",
        "italic",
        "underline",
        "color",
        "background",
        "list",
        "bullet",
    ];

    return (
        <div
            className={`${containerClassName}  dark:text-white mb-10 sm:mb-5 flex flex-col gap-2`}
        >
            <style>{`
                .idv-text-editor {
                    display: flex;
                    flex-direction: column;
                }
                .idv-text-editor .ql-container {
                    flex: 1 1 auto;
                    height: auto;
                }
                .idv-text-editor .ql-editor {
                    height: 100%;
                }
            `}</style>
            <label
                htmlFor={name}
                className="text-sm font-semibold text-gray-700 dark:text-gray-300"
            >
                {label}
                {required && (
                    <span className="font-medium text-[#F51515] ml-2">*</span>
                )}
            </label>

            <div style={{ height: height, width: "100%", overflow: "hidden" }}>
                <ReactQuill
                    className="idv-text-editor"
                    theme="snow"
                    value={value || ""}
                    onChange={(content) => handleChange(name, content)}
                    modules={modules}
                    formats={formats}
                    placeholder={placeholder}
                    readOnly={readOnly}
                    style={{ height: "100%", width: "100%" }}
                />
            </div>

            {error && (
                <p className="mt-10 text-sm text-red-600" id={`${name}-error`}>
                    {error}
                </p>
            )}
        </div>
    );
}
